<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px;"
          type="text"
          icon="el-icon-back"
          @click="cancel()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="奖品类型" prop="type">
        <el-radio-group v-model="ruleForm.type">
          <el-radio :label="1" :disabled="action == 'edit' || action == 'copy'"
            >体验营</el-radio
          >
          <el-radio :label="2" :disabled="action == 'edit' || action == 'copy'"
            >实物奖品</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.type == 1"
        label="选择课程"
        prop="course_title"
      >
        <el-col :span="10">
          <el-input
            v-model="ruleForm.course_title"
            placeholder="请选择课程"
            :disabled="true"
          >
          </el-input>
        </el-col>
        <el-button
          class="add_class"
          type="primary"
          size="mini"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
        >
          选择课程
        </el-button>
      </el-form-item>
      <el-form-item v-if="ruleForm.type == 2" label="奖品名称" prop="title">
        <el-col :span="10">
          <el-input
            v-model="ruleForm.title"
            placeholder="请填写奖品名称（20字以内）"
            :disabled="false"
          >
          </el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="主图" v-if="ruleForm.type == 2" prop="img_url">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload2"
        >
          <img v-if="ruleForm.img_url" :src="ruleForm.img_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            尺寸宽最大335*335PX，大小不超过100K
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="中奖名额" prop="lottery_num">
        <el-input-number
          v-model="ruleForm.lottery_num"
          :precision="0"
          :min="1"
          :max="100"
          @change="lotteryNumChange()"
          label="描述文字"
        ></el-input-number>
        人
      </el-form-item>
      <el-form-item label="虚拟参与人数" prop="virtual_number" label-width="110px">
        <el-input-number
          v-model="ruleForm.virtual_number"
          :precision="0"
          :min="ruleForm.lottery_num"
          :max="100"
          label="描述文字"
        ></el-input-number>
        人
      </el-form-item>
      <el-form-item label="开奖时间" prop="lottery_duration">
        <el-input-number
          v-model="ruleForm.lottery_duration"
          :precision="0"
          :min="1"
          :max="20"
          label="描述文字"
        ></el-input-number>
        分钟
      </el-form-item>
      <el-form-item label="参与方式" prop="join_way_content" id="canyufangshi">
        <el-select v-model="ruleForm.join_way">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option
        ></el-select>
        <el-input
          v-model="ruleForm.join_way_content"
          placeholder="自定义评论内容（20字以内）"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="中奖用户可重复抽奖"
        prop="repeat_lottery"
        label-width="150px"
      >
        <el-radio-group v-model="ruleForm.repeat_lottery">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          type="primary"
          :loading="updateLoading"
          @click="submitForm('ruleForm')"
          >{{ action == "edit" ? "保存" : "创建福袋" }}</el-button
        >
        <el-button size="small" @click="cancel()">取 消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择课程"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item label="课程名称：">
          <el-input
            size="mini"
            v-model="search.query.search"
            placeholder="课程名称/ID"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="search.query.page=1; searchData()">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          prop="released_at"
          label="发布时间"
          align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="
                ruleForm.course_title = row.id + '，' + row.title;
                ruleForm.target_id = row.id;
                search.chooseOrgVisible = false;
              "
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { screenProductList, createUpdate, getInfo } from "@/api/coupon";
import {
  beforeImageUpload2,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";
export default {
  data: function () {
    return {
      ossAction: "",
      newid: 0,
      id: this.$route.query.id,
      action: this.$route.query.action, //create-新建，edit-编辑，copy-复制
      updateLoading: false,
      ruleForm: {
        course_id: this.$route.query.course_id,
        period_id: this.$route.query.period_id,
        id: this.$route.query.action == "edit" ? this.$route.query.id : 0, //
        type: 1, // 类型
        title: "",
        course_title: "", // 课程标题
        img_url: "", // 商品图片
        target_id: 0, //  课程id
        lottery_num: 1, // 中奖名额
        virtual_number: 1,
        lottery_duration: 10, // 开奖时间
        join_way: "", // 参与方式
        join_way_content: "", // 评论内容
        repeat_lottery: 1, // 是否重复抽奖
      },
      search: {
        chooseOrgVisible: false,
        chooseOrgVisible2: false,
        listLoading1: false,
        activeName: "19",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 19,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      //title img_url
      rules: {
        type: [
          { required: true, message: "请选择福袋类型", trigger: "change" },
        ],
        course_title: [
          { required: true, message: "请输入选择体验营课程", trigger: "blur" },
        ],
        img_url: [{ required: true, message: "请上传图片", trigger: "blur" }],
        title: [
          { required: true, message: "请输入奖品名称", trigger: "blur" },
          { min: 1, max: 20, message: "最多不超过20个字", trigger: "blur" },
        ],
        lottery_num: [
          { required: true, message: "中奖名额为1~100人", trigger: "blur" },
          // { min: 1, message: "最少不低于1人", trigger: "blur" },
          // { max: 100, message: "最多不超过100人", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback(new Error("中奖名额不能为空"));
              }
              setTimeout(() => {
                // if (!Number.isInteger(value)) {
                //   callback(new Error("请输入数字值"));
                // } else {
                //   if (value < 1 || value > 100) {
                //     callback(new Error("中奖名额为1~100人"));
                //   } else {
                //     callback();
                //   }
                // }
                if (value < 1 || value > 100) {
                    callback(new Error("中奖名额为1~100人"));
                  } else {
                    callback();
                  }
              }, 1000);
            },
          },
        ],
        virtual_number: [
          { required: true, message: "虚拟参与人数为1~100人", trigger: "blur" },
          // { min: 1, message: "最少不低于1人", trigger: "blur" },
          // { max: 100, message: "最多不超过100人", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback(new Error("虚拟参与人数不能为空"));
              }
              setTimeout(() => {
                if (value < 1 || value > 100) {
                    callback(new Error("虚拟参与人数为1~100人"));
                  } else {
                    callback();
                  }
              }, 1000);
            },
          },
        ],
        lottery_duration: [
          { required: true, message: "开奖时间为1~20分钟", trigger: "blur" },
          // { min: 1, message: "最少不低于1分钟", trigger: "blur" },
          // { max: 20, message: "最多不超过20分钟", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback(new Error("开奖时间不能为空"));
              }
              setTimeout(() => {
                // if (!Number.isInteger(value)) {
                //   callback(new Error("请输入数字值"));
                // } else {
                //   if (value < 1 || value > 20) {
                //     callback(new Error("开奖时间为1~20分钟"));
                //   } else {
                //     callback();
                //   }
                // }
                if (value < 1 || value > 20) {
                    callback(new Error("开奖时间为1~20分钟"));
                  } else {
                    callback();
                  }
              }, 1000);
            },
          },
        ],
        join_way_content: [
          { required: true, message: "请输入自定义评论内容", trigger: "blur" },
          { min: 1, max: 20, message: "最多不超过20个字", trigger: "blur" },
        ],
        repeat_lottery: [
          {
            required: true,
            message: "请选择中奖用户是否可重复抽奖",
            trigger: "blur",
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "评论指定内容",
        },
      ],
      optionsvalue: "",
      files: {},
    };
  },
  mounted() {
    if (this.action != "create") {
      this.getInfoList();
    }
  },
  methods: {
    lotteryNumChange() {
      if (this.ruleForm.virtual_number < this.ruleForm.lottery_num) {
        this.ruleForm.virtual_number = this.ruleForm.lottery_num
      }
    },
    getInfoList() {
      let getInfoList = {
        id: this.$route.query.id,
      };
      getInfo(getInfoList).then((response) => {
        this.ruleForm = response.data;
        this.ruleForm.lottery_duration = String(
          response.data.lottery_duration / 60
        );
        if (response.data.type == 1) {
          this.ruleForm.course_title = response.data.title;
        }
        this.ruleForm.join_way = String(response.data.join_way)
      });
    },

    beforeImageUpload2(file) {
      this.files = file;
      console.log(file);
      beforeImageUpload2(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.ruleForm.img_url = fileUrl;
          console.log(this.ruleForm.img_url);
        });
      });
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "19";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 19;
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = this.search.chooseOrgVisible2 = false;
    },

    searchData() {console.log(this.search.query)
      // 选择课程列表
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    cancel() {
      //this.$router.go(-1);
      
      console.log(JSON.stringify(this.$data.ruleForm) == JSON.stringify(this.$options.data.call(this).ruleForm))
      if (JSON.stringify(this.$data.ruleForm) == JSON.stringify(this.$options.data.call(this).ruleForm)) {
        this.$router.go(-1);
      } else {
        this.$confirm("有未提交的内容，是否放弃提交?", "提示", {
          confirmButtonText: "放弃",
          cancelButtonText: "取消",
          type: "warning",
          //center: true,
        }).then(() => {
          this.$router.go(-1);
        }).catch(() => {

        });
      }
    },
    submitForm(formName) {

      this.ruleForm.lottery_duration = String(this.ruleForm.lottery_duration);
      this.ruleForm.lottery_num = String(this.ruleForm.lottery_num);
      this.ruleForm.virtual_number = String(this.ruleForm.virtual_number);
      console.log(this.$refs.ruleForm.model);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arrfoem = {
            course_id: this.ruleForm.course_id,
            period_id: this.ruleForm.period_id,
            id: this.action == "copy" ? 0 : this.ruleForm.id,
            type: this.ruleForm.type,
            title: this.ruleForm.title,
            course_title: this.ruleForm.course_title,
            img_url: this.ruleForm.img_url,
            target_id: this.ruleForm.target_id,
            lottery_num: this.ruleForm.lottery_num,
            virtual_number: this.ruleForm.virtual_number,
            lottery_duration: this.ruleForm.lottery_duration * 60,
            join_way_content: this.ruleForm.join_way_content,
            join_way: this.ruleForm.join_way,
            repeat_lottery: this.ruleForm.repeat_lottery, // 是否重复抽奖
          };
          console.log(this.ruleForm.type);
          if (
            this.ruleForm.type == 2 &&
            this.action == "create" &&
            beforeImageUpload2(this.files)
          ) {
            createUpdate(arrfoem).then((response) => {
              // this.search.listLoading1 = true;
              if (response.code == 1) {
                this.updateLoading = false;
                this.$router.go(-1);
              }
            });
          }
          if (this.ruleForm.type == 1 || this.action != "create") {
            createUpdate(arrfoem).then((response) => {
              // this.search.listLoading1 = true;
              if (response.code == 1) {
                this.updateLoading = false;
                this.$router.go(-1);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
.el-form-item .el-form-item__content .add_class {
  height: 40px;
  margin-left: 10px;
}
.el-form #canyufangshi .el-form-item__label {
  display: flex;
}
.el-form-item .prize_info label ::before {
  width: 300px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-form-item > .el-form-item__content > .avatar-uploader > .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 确认窗 取消确认按钮位置更换 */
.el-message-box__wrapper .el-message-box__btns {
  display: flex;
  flex-flow: row-reverse;
}

.el-message-box__wrapper .el-message-box__btns .el-button {
  margin-left: 10px;
}
</style>
